// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithClass } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class ListPanel extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineItems();
  }

  determineItems() {
    const query = new DomQuery(this.element);
    const items = query.getChildren(WithClass("Item"));

    for (const item of items) {
      if (item.classList.contains("Add"))
        item.childNodes[0].onclick = this.createToggleSectionHandler(item);
    }
  }

  createToggleSectionHandler(element) {
    return function (event) {
      if (element.classList.contains("Expanded"))
        element.classList.remove("Expanded");
      else
        element.classList.add("Expanded");
    };
  }
}

interactivityRegistration.register("ListPanel", function (element) { return new ListPanel(element); });
